export default "__VITE_ASSET__58223723__"